import {
  gql 
} from "@apollo/client";

export const GET_PRODUCT_FILTERS = gql`
    query getProductFilters(
        $search: String
        $filters: ProductAttributeFilterInput
    ) {
        productFilters: products(search: $search, filter: $filters) {
            aggregations {
                label
                count
                attribute_code
                options {
                    count
                    label
                    value
                    alis_value
                    parent_id
                    url_key
                    swatch_data {
                        type
                        value
                    }
                }
            }
        }
    }
`;
